import React, { FunctionComponent } from 'react';
import styles from './ElementListItem.module.scss';

interface Props {
    id?: string;
    name: string;
    img?: string;
    showImage?: boolean;
    isFirst?: boolean;
    isLast?: boolean;
    onSelect: () => void;
}

export const ElementListItem: FunctionComponent<Props> = props => {
    return (
        <button
            id={props.id}
            type="button"
            className={styles.listItem}
            data-first={props.isFirst || undefined}
            data-last={props.isLast || undefined}
            onClick={props.onSelect}
        >
            {props.showImage &&
                (props.img ? (
                    <span className={styles.imageWrapper}>
                        <img
                            src={props.img}
                            alt=""
                            className={styles.image}
                        />
                    </span>
                ) : (
                    <span className={styles.imagePlaceholder} />
                ))}
            <span className={styles.name}>{props.name}</span>
        </button>
    );
};

export default ElementListItem;
